import React from 'react';
import WidgetBase, { BaseList } from './WidgetBase';
import moment from 'moment';

const LarianTechBSCUsageWidget = ({ data }) => {
	const grouped = data.reduce((all, current) => {
		all[current?.deviceId] =
			all[current?.deviceId] !== undefined
				? all[current?.deviceId] + current?.data?.duration
				: current?.data?.duration;

		return all;
	}, {});

	const list = Object.keys(grouped)
		.map((key) => ({
			key,
			duration: grouped[key],
		}))
		.sort((a, b) => b.duration - a.duration);
	return (
		<WidgetBase title="Top Usage">
			<BaseList
				items={list.map(({ key, duration }) => {
					return {
						children: (
							<div>{`Device: ${key} - ${moment
								.duration(duration, 'milliseconds')
								.humanize()}`}</div>
						),
					};
				})}
			/>
		</WidgetBase>
	);
};

export default LarianTechBSCUsageWidget;
